module.exports = __webpack_public_path__ + "img/background-30.b4138c13.jpg";